export interface WhiteLabelInfoLike {
    appName?: string | null;
    isSitesec?: boolean | null;
    isVideoloft?: boolean | null;
}

export const isVideoloftWhiteLabel = (
    whiteLabelInfo?: WhiteLabelInfoLike | null
) =>
    whiteLabelInfo?.isVideoloft === true ||
    whiteLabelInfo?.appName?.toLowerCase() === 'videoloft';

export const isSitesecWhiteLabel = (
    whiteLabelInfo?: WhiteLabelInfoLike | null,
    host = ''
) =>
    whiteLabelInfo?.isSitesec === true ||
    /sitesec/i.test(whiteLabelInfo?.appName ?? '') ||
    /sitesec/i.test(host);
